/* eslint-disable prefer-arrow/prefer-arrow-functions */
import { ProjectLookupContactType } from '@/data/web-api-client';
import repository from '@/services/repository';

const resource = '/projects';

export default {
    get() {
        return repository.get<IProject[]>(`${resource}`);
    },
    lookup(options: any, searchText?: string, contactId?: string, contactType?: ProjectLookupContactType) {
        const formData = new FormData();

        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        if (!contactId) {
            contactId = '';
        }
        if (!searchText) {
            searchText = '';
        }
        if (!contactType) {
            contactType = ProjectLookupContactType.All;
        }

        return repository.post(`${resource}/lookup?contactId=${contactId}&searchText=${searchText}&type=${contactType}`,
            formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
    getStats() {
        return repository.get<IProjectStats>(`${resource}/stats`);
    },
    getUsedArticles(id: string) {
        return repository.get<string[]>(`${resource}/${id}/Codes`);
    },
    getSingle(id: string) {
        return repository.get<IProject>(`${resource}/${id}`);
    },
    getPageInfo(id: string) {
        return repository.get<any>(`${resource}/${id}/pageInfo`);
    },
    duplicateProject(command: IProjectCopyCommand) {
        return repository.post<IProject>(`${resource}/${command.projectId}/copy`, command);
    },
    getProjectContacts(id: string) {
        return repository.get<IProjectAssignedContact[]>(`${resource}/${id}/contacts`);
    },
    create(payload: any) {
        return repository.post(`${resource}`, payload);
    },
    update(payload: any) {
        payload.defaultPrice = null;
        return repository.put(`${resource}/${payload.id}`, payload);
    },
    updateContacts(payload: any) {
        return repository.put(`${resource}/${payload.id}/contacts`, payload);
    },
    updateLocation(payload: any) {
        return repository.put(`${resource}/${payload.id}/location`, payload);
    },
    delete(payload: any) {
        return repository.delete(`${resource}/${payload.id}`);
    },
    updateCosts(payload: any) {
        return repository.post(`${resource}/${payload.projectId}/Costs`, payload);
    },
    getMeasurementStats() {
        return repository.get('measurements/stats');
    },
    duplicateMeasurement(id: string, payload: IMeasurementDuplicateDtu) {
        return repository.post(`${resource}/${id}/measurements/Duplicate`, payload);
    },
    createMeasurement(id: string, payload: IMeasurement) {
        return repository.post(`${resource}/${id}/measurements`, payload);
    },
    updateMeasurement(id: string, name: string, payload: IMeasurement, timestamp: string) {
        return repository.put(`${resource}/${id}/measurements/${name}?timestamp=${timestamp}`, payload);
    },
    deleteMeasurement(id: string, payload: IMeasurement) {
        return repository.delete(`${resource}/${id}/measurements/${payload.documentNumber.replace('/', '-').replace('/', '-')}`);
    },
    createLog(id: string, payload: ILog) {
        return repository.post(`${resource}/${id}/addLog`, payload);
    },
    generateMeasuringState(id: string, quotationIds: string[]) {
        return repository.post(`${resource}/${id}/measuringstates/generate`, quotationIds);
    },
    getFiles(request: IFileLookupRequest) {
        return repository.post(`projects/Files`, request);
    },
    getProgressStatement(id: string) {
        return repository.get(`${resource}/${id}/ProgressStatements`);
    },
    getSingleProgressStatement(documentNumber: string) {
        return repository.get(`ProgressStatements/${documentNumber}`);
    },
    getProgressStatementProjectData(documentNumber: string) {
        return repository.get(`ProgressStatements/${documentNumber}/ProjectData`);
    },
    postProgressStatementProjectData(documentNumber: string, data: any) {
        return repository.post(`ProgressStatements/${documentNumber}/ProjectData`, data);
    },
    createProgressStatement(id: string) {
        return repository.post(`${resource}/${id}/ProgressStatements`);
    },
    updateProgressStatement(documentNumber: string, payload: IProgressStatement) {
        return repository.put(`ProgressStatements/${documentNumber}`, payload);
    },
    deleteProgressStatement(documentNumber: string) {
        return repository.delete(`ProgressStatements/${documentNumber}`);
    },
    generateProgressStatement(payload: any) {
        return repository.post(`${resource}/ProgressStatements`, payload);
    },
    getZipData(options: any, projectId: string) {
        const formData = new FormData();

        for (const key in options) {
            if (options.hasOwnProperty(key)) {
                formData.append(key, JSON.stringify(options[key]));
            }
        }

        return repository.post(`${resource}/getZipData?projectId=${projectId}`,
            formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },
};
